import React from 'react'
import { DEFAULT_FILTERS } from './filters'
import { FilteredContacts } from './contacts'
import { InboxTab } from './inboxes'
import { Message, MessageData } from './message'
import { Loader } from '../../components/simple/loader'
import { Button } from '../../components/simple/button'
import { usePaginatedData } from '../../request'

interface MessagesProps {
  filteredContacts: FilteredContacts
  messageSelected: (message: MessageData) => void
  selectedMessageID: number | undefined
}

export const AttendanceMessages: React.FC<MessagesProps> = React.memo(
  ({ filteredContacts, messageSelected, selectedMessageID }) => {
    const messagePostData = React.useMemo(
      () => ({
        filters: DEFAULT_FILTERS,
        filteredContacts,
        tab: InboxTab.Attendance,
      }),
      [filteredContacts]
    )
    const {
      values: messages,
      loadingMore,
      loading: messagesLoading,
      loadMore,
    } = usePaginatedData<MessageData, typeof messagePostData>('/frontend_api/getMessages', messagePostData)

    return (
      <>
        <div className="z-20 flex min-h-[49.59px] items-center justify-between gap-2 p-[8px] shadow">
          <b className="ml-2 text-lg">Attendance Records</b>
          <Button link="/stats/attendance" openInNewTab>
            View Attendance Stats
          </Button>
        </div>
        <div className="flex-grow overflow-y-auto overflow-x-hidden bg-slate-50 px-[.375rem]">
          {!messages || (messagesLoading && messages.length === 0) ? (
            <Loader />
          ) : messages.length > 0 ? (
            <>
              {messages.map((message) => (
                <Message
                  key={message.id}
                  message={message}
                  onSelect={messageSelected}
                  selected={selectedMessageID === message.id}
                  tab={InboxTab.Attendance}
                  disabled={messagesLoading}
                />
              ))}
              {loadMore ? (
                <Button className="mx-auto my-3" logo small onClick={loadMore} disabled={loadingMore}>
                  Load More
                </Button>
              ) : (
                <Button className="mx-auto my-3 cursor-default opacity-0">Load More</Button>
              )}
            </>
          ) : (
            <div className="mt-8 text-center">No Attendance Records Found</div>
          )}
        </div>
      </>
    )
  }
)
